import { inRange } from 'lodash';
import { MessagePlugin } from 'tdesign-react';

import { ImageRatio } from '@/const/richMedia';
import { getImageSizeAsync } from '@/utils/getImageSize';

import { ImageRatioType } from '..';

// 从 URL 中获取图片类型
const getImageTypeFromUrl = (url: string): string => {
  if (!url) return '';

  // 匹配文件扩展名
  const match = url.match(/\.(jpeg|jpg|png|gif|webp|bmp|svg)(\?|$)/i);
  if (match) {
    return match[1].toLowerCase();
  }
  return '';
};

// 检查图片类型是否合法
export const isPicType = (typeOrUrl: string, typeLimit: string[]) => {
  let actualExt = '';
  if (typeOrUrl.includes('.')) {
    // 如果是 URL，提取扩展名
    actualExt = getImageTypeFromUrl(typeOrUrl);
  } else if (typeOrUrl.includes('/')) {
    // 如果是 MIME 类型，提取扩展名
    actualExt = typeOrUrl.split('/')[1] || '';
  }
  const valid = actualExt ? typeLimit?.includes(actualExt) : true;
  if (!valid) {
    MessagePlugin.error(`格式：${typeLimit?.join('、')}`);
  }
  return valid;
};

// 检查图片大小是否合法
export const isPicSize = (
  size: number,
  sizeLimit: number,
) => {
  const valid = size <= sizeLimit * 1024 * 1024;
  if (!valid) {
    MessagePlugin.error(`大小：不超过 ${sizeLimit}MB`);
  }
  return valid;
};

// 检查图片宽高是否合法
export const checkWH = (
  file: any,
  width?: number,
  height?: number,
) => new Promise<boolean>((resolve, reject) => {
  const filereader = new FileReader();
  filereader.onload = (e: any) => {
    const src = e.target.result;
    const image = new Image();
    image.onload = () => {
      let widthRange = true;
      let heightRange = true;

      if (width) {
        widthRange = inRange(image.width, width - 10, width + 10);
      }
      if (height) {
        heightRange = inRange(image.height, height - 10, height + 10);
      }

      if (widthRange && heightRange) {
        resolve(true);
      } else {
        MessagePlugin.error(`尺寸：${width || '不限'} * ${height || '不限'}`);
        reject(false);
      }
    };
    image.onerror = reject;
    image.src = src;
  };
  filereader.readAsDataURL(file.raw);
});

// 检查图片比例是否合法
export const checkImageRatio = async (url?: string, ratio?: ImageRatioType) => {
  if (!url || !ratio || ratio === ImageRatio.unlimited) return true;

  let isValid = false;
  const { width, height } = await getImageSizeAsync(url);
  if (width && height) {
    const inputRatio = width / height;
    if ('min' in ratio && 'max' in ratio) {
      isValid = inputRatio >= ratio.min && inputRatio <= ratio.max;
    } else {
      const expectedRatio = ratio.width / ratio.height;
      isValid = Math.abs(inputRatio - expectedRatio) <= 0.01;
    }
  }

  return isValid;
};
